import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import CheckoutBlank from '../checkout/checkoutBlank'
import { error } from '../common/helpers/toastify'
import { useTranslation } from 'react-i18next';
import { posreceivepayment_head } from '../../components/common/Tablehead'
import { _Api } from '../common/api/_call'
import { Reseivesubtable } from "../Custom/subtable/Reseivesubtable";
import { useDispatch, useSelector } from 'react-redux'
import { updateCustomer, updateSaleperson } from '../../source/app/appSlice'
import CheckoutPayment from '../checkout/checkoutPayment'
import { toFormatPrice } from '../common/helpers/function';
import moment from 'moment';
import TableActionMenu, { toggleTableActionMenu } from '../common/module/TableActionMenu';

const parseReceiveDate = (value) => {
  if (!value) return null;
  const parsed = moment(
    value,
    ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "YYYY-MM-DD", "DD-MM-YYYY"],
    true
  );
  if (parsed.isValid()) return parsed.valueOf();
  const fallback = moment(value);
  return fallback.isValid() ? fallback.valueOf() : null;
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(num) ? null : num;
};

// Sort accessor per column index of posreceivepayment_head.
const SORT_ACCESSORS = [
  null,
  (r) => parseReceiveDate(r?.date),
  (r) => r?.vr_type,
  (r) => r?.vr_no,
  (r) => r?.SKU,
  (r) => r?.customer,
  (r) => toNumber(r?.amount),
  (r) => toNumber(r?.payment),
  (r) => toNumber(r?.outstanding),
  (r) => r?.location,
  (r) => parseReceiveDate(r?.due_date),
  null,
];

// Row/expand ids differ per tab so the three tables never clash in the DOM.
const TAB_CONFIG = {
  ALL: { rowPrefix: 'common-main-table-wrap-', btnPrefix: 'table-btn_', expandClass: 'table_btn_expand_col' },
  LayBy: { rowPrefix: 'common-main-table-wrap1-', btnPrefix: 'table-btn1_', expandClass: 'table_btn_expand_col1' },
  Installment: { rowPrefix: 'common-main-table-wrap2-', btnPrefix: 'table-btn2_', expandClass: 'table_btn_expand_col2' },
};

const ReceivePayment = () => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const generalsettings = useSelector((state) => state.app.generalsettings)
  const customer = useSelector((state) => state.app.customer)
  const saleperson = useSelector((state) => state.app.saleperson)
  const [newcolumndata, setnewcolumndata] = useState(posreceivepayment_head)
  const [reseivedata, setReseivedata] = useState([])
  const [paytype, setpaytype] = useState('ALL')
  const [order_id, setOrder_id] = useState();
  const [searchname, setSearchname] = useState('');
  const [showcheckout, setShowcheckout] = useState('blank')
  const [UpdatedCart, setUpdatedCart] = useState()
  const [laybyid, setLaybyid] = useState()
  const [excuteTable, setexcuteTable] = useState(false);
  const [custom_order_id, setCustom_order_id] = useState()
  const [laybylist, setLaybylist] = useState([])
  const [greandtotal, setGreandtotal] = useState(0)
  const [sortConfig, setSortConfig] = useState({ index: null, direction: 'asc' })
  // { key, row, tab, top, left, width, height } of the open action menu.
  const [actionMenu, setActionMenu] = useState(null)
  const closeActionMenu = useCallback(() => setActionMenu(null), [])

  const columns = Array.isArray(newcolumndata) && newcolumndata.length ? newcolumndata : posreceivepayment_head
  const isColumnVisible = (index) => columns[index]?.status !== false

  const callcolumns = async () => {
    try {
      const postdata = {
        name: 'report_receivepayment_tbl',
      }
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      )
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    callcolumns()
  }, [])
  const getreseivepayment = async () => {

    setexcuteTable(false);
    setActionMenu(null);

    document.querySelectorAll(".table_btn_expand_col, .table_btn_expand_col1, .table_btn_expand_col2")
      .forEach((expand_col) => expand_col.classList.remove("rotate-90"));

    try {
      let postdata = {
        "type": paytype,
        "search": searchname
      }
      let res = await _Api(postdata, `api/v1/POS/receive/LayByList`);
      if (res?.code === 200) {
        setReseivedata(res?.data || []);
        setexcuteTable(true);
      } else {
        setReseivedata([]);
      }
    }
    catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    getreseivepayment()
    // eslint-disable-next-line
  }, [paytype])

  const handleSort = (index) => {
    setSortConfig((prev) =>
      prev.index === index
        ? { index, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { index, direction: 'asc' }
    );
  };
  const sortedData = useMemo(() => {
    const list = Array.isArray(reseivedata) ? reseivedata : [];
    const accessor = SORT_ACCESSORS[sortConfig.index];
    if (!accessor) return list;
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null || av === "") return 1;
      if (bv === undefined || bv === null || bv === "") return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === 'asc' ? sorted : sorted.reverse();
  }, [reseivedata, sortConfig]);

  const setsubtable = async (id, order_type, tab) => {
    var e = document.querySelector("#" + TAB_CONFIG[tab].btnPrefix + id);
    if (!e) return;
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      setReseivedata((prev) => prev.map((item) => item.id === id ? { ...item, subTabledata: null } : item));
    } else {
      classList_.add("rotate-90");
      const postdata = {
        "id": id,
        "type": order_type
      };
      let prioritydata = await _Api(postdata, `api/v1/POS/receive/getLayBySKUList`);
      var html_ = Reseivesubtable(prioritydata, id, t);
      setReseivedata((prev) => prev.map((item) => item.id === id ? { ...item, subTabledata: html_ } : item));
    }
  }
  const filterbyname = () => {
    getreseivepayment();
  }
  const callpayementcheckout = async (amount, order_type, installmentarray, rowCustomer, rowSalesPerson) => {
    // The redux customer only updates after this render, so use the row's directly.
    const payCustomer = rowCustomer?.id ? rowCustomer : customer;
    if (!payCustomer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!rowSalesPerson?.value && !saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    try {
      const postdata = {}
      const credit_notepostdata = {
        customer_id: payCustomer?.id
      }
      let res = await _Api(
        postdata,
        `api/v1/POS/checkout/payment/getCashMethodList`,
      )
      let res_credit_note = await _Api(
        credit_notepostdata,
        `api/v1/POS/checkout/creditnote/getCreditNote`,
      )
      if (res.code === 200) {
        setUpdatedCart({
          sell_info: {
            cart: [],
            deletecart_ids: [],
            summary_order: {},
            status_type: order_type,
            totalamount: amount,
            park_id: ''
          },
          totalamount: amount,
          receivestatus: 'receivepay',
          installmentarray: installmentarray ? installmentarray : [],
          payment_Options: res?.data,
          credit_note_options: res_credit_note?.data,
          oldcredit_note_options: res_credit_note?.data,
        })
        setShowcheckout('payment')
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }

  const receiveRow = (result, tab) => {
    // The payment belongs to this order's customer, whoever was selected before.
    const rowCustomer = result?.customer_details;
    if (rowCustomer?.id) {
      dispatch(updateCustomer(rowCustomer));
      localStorage.setItem('customerdetails', JSON.stringify(rowCustomer));
      localStorage.removeItem('addcustomerdtaa');
    }
    const rowSalesPerson = result?.sales_person_details;
    if (rowSalesPerson?.value) {
      dispatch(updateSaleperson(rowSalesPerson));
      localStorage.setItem('salesdetails', JSON.stringify(rowSalesPerson));
    }
    if (tab === 'LayBy') {
      callpayementcheckout(result?.outstanding, result?.order_type, undefined, rowCustomer, rowSalesPerson);
    } else {
      callpayementcheckout(result?.outstanding, result?.order_type, result?.installment, rowCustomer, rowSalesPerson);
    }
    setOrder_id(result?.order_id);
    setCustom_order_id(result?.custom_order_id)
    if (tab !== 'Installment') {
      setLaybylist(result?.pay_layby_data)
      setGreandtotal(result?.amount)
      setLaybyid(result?.id)
    }
  }

  const renderActionMenuItems = (result, tab) => {
    const showPrint = tab === 'ALL' ? result?.printURL !== "" : true;
    return (
      <>
        {result?.status?.is_pending !== 0 ?
          <li
            onClick={() => receiveRow(result, tab)}
            className="dropdown-item img-btn-hover">
            <div className="dropdown-menu-img">
              <img className='img-btn-hover-img-1' src={base_assets + 'images/pos/icons/i6.png'} alt="" />
              <img className='img-btn-hover-img-2' src={base_assets + 'images/pos/icons/i6w.png'} alt="" />
            </div>
            {t("Receive")}
          </li>
          : ''
        }
        {showPrint ?
          <li className="dropdown-item img-btn-hover"
            onClick={() => {
              if (result?.printURL) {
                window.open(result?.printURL, '_blank', 'noreferrer')
              }
            }}>
            <div className="dropdown-menu-img">
              <img className='img-btn-hover-img-1' src={base_assets + 'images/pos/report/print-icon.png'} alt="" />
              <img className='img-btn-hover-img-2' src={base_assets + 'images/pos/icons/print-icon-w.png'} alt="" />
            </div>
            {t("print")}
          </li>
          : ''
        }
        <li data-bs-toggle="modal">
          <Link className="dropdown-item img-btn-hover" to="#">
            <div className="dropdown-menu-img">
              <img className='img-btn-hover-img-1' src={base_assets + 'images/pos/icons/i5.png'} alt="" />
              <img className='img-btn-hover-img-2' src={base_assets + 'images/pos/icons/i5w.png'} alt="" />
            </div>
            {t("Delete")}
          </Link>
        </li>
      </>
    );
  };

  const renderHead = () => (
    <thead>
      <tr>
        {columns.map((col, index) => {
          if (!isColumnVisible(index)) return null;
          const sortable = Boolean(col?.sort) && Boolean(SORT_ACCESSORS[index]);
          const active = sortConfig.index === index;
          return (
            <th
              key={index}
              className={col?.class}
              onClick={sortable ? () => handleSort(index) : undefined}
              style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff', padding: '0 0.6vw', cursor: sortable ? 'pointer' : undefined }}
            >
              {t(col?.lable)}
              {sortable ? (
                <div className="up-down-arrow-btn">
                  <img
                    className={"up-down-arrow-img up-down-arrow-img-forward" + (active && sortConfig.direction === 'desc' ? "" : " active")}
                    src={base_assets + "images/icons/up-down-arrow.png"}
                    alt=""
                  />
                  <img
                    className={"up-down-arrow-img up-down-arrow-img-reverse" + (active && sortConfig.direction === 'desc' ? " active" : "")}
                    src={base_assets + "images/icons/up-down-arrow-reverse.png"}
                    alt=""
                  />
                </div>
              ) : null}
            </th>
          );
        })}
      </tr>
    </thead>
  );

  const renderCells = (result, key, tab) => {
    const config = TAB_CONFIG[tab];
    const cells = [
      <td key="0">{key + 1}</td>,
      <td key="1"> {result?.date ? result?.date : ""}</td>,
      <td key="2">{result?.vr_type ? result?.vr_type : ""}</td>,
      <td key="3" className="link-color">{result?.vr_no ? result?.vr_no : ""}</td>,
      <td key="4" className={`link-color link-color sku-col ${config.expandClass}`}
        onClick={() => setsubtable(result?.id, result?.order_type, tab)}
        id={config.btnPrefix + result?.id}>
        <img
          className="sku-col-arrow cursor-pointer"
          src={base_assets + "/images/icons/right_green_button.png"}
          alt=""
        />{result?.SKU ? result?.SKU : ""}</td>,
      <td key="5">{result?.customer ? result?.customer : ""}</td>,
      <td key="6">{toFormatPrice(result?.amount, { addSymbol: true })}</td>,
      <td key="7" className='main-green-text'>{toFormatPrice(result?.payment, { addSymbol: true })}</td>,
      <td key="8" className='danger-text'>{toFormatPrice(result?.outstanding, { addSymbol: true })}</td>,
      <td key="9">{result?.location ? result?.location : ""}</td>,
      <td key="10">{result?.due_date ? result?.due_date : ""}</td>,
      <td key="11">
        <div className="customer-table-dropdown dropdown">
          <button
            className="btn-style dropdown-toggle show"
            type="button"
            data-table-action-btn
            onClick={(event) =>
              setActionMenu(toggleTableActionMenu(event, `${tab}-${result?.id}`, { row: result, tab }))
            }
          >
            <img src={base_assets + 'images/icons/ellipsis-circular.png'} alt="" />
          </button>
        </div>
      </td>,
    ];
    return cells.filter((_, index) => isColumnVisible(index));
  };

  const renderTable = (tableId, tab) => (
    <div
      className="main-body-main-table-wrap Dailysalereport-table mt-4"
      style={{ maxHeight: '52vh', overflow: 'auto' }}
    >
      <table
        id={tableId}
        className="common-table first-row-gray w-100 quotation-table Dailysalereport-table-main"
      >
        {renderHead()}
        <tbody>
          {sortedData.length ? sortedData.map((result, key) => (
            <React.Fragment key={result?.id ?? key}>
              <tr
                id={TAB_CONFIG[tab].rowPrefix + result?.id}
                onClick={() => setLaybyid(result?.id)}
              >
                {renderCells(result, key, tab)}
              </tr>
              {excuteTable && result?.subTabledata ? result.subTabledata : null}
            </React.Fragment>
          )) : (
            <tr>
              <td colSpan={columns.filter((_, index) => isColumnVisible(index)).length} className="text-center">
                {t("No Data Available In Table")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0 quotation">
            <div className="com-data-area">
              <div className="catalog-area-header-area detail-area-header">
                <div className="catalog-area-header-area-control">
                  <div className="catalog-area-header-area-control-left">
                    <h3 className='common-navigation-header-left-heading'> <Link to="/app/pos/receive" className='gray-mid text-decoration-none'>{t("Receive")} </Link>
                      <img
                        className='Dailysalereport-head-arrow mx-3'
                        src={base_assets + "images/pos/report/arrow-right.png"}
                        alt=""
                      /> {t("Receive Payment")}</h3>
                  </div>
                  <div className="catalog-area-header-area-control-right">
                    <div className="com-search-area">
                      <input
                        type="text"
                        value={searchname}
                        onChange={(e) => setSearchname(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && filterbyname()}
                        placeholder={t("Search By Invoice/SKU/Stock ID/Location")}
                      />
                      <img onClick={filterbyname} className="com-search-area-img" src={base_assets + "images/pos/icons/magnifying-glass.png"} alt="" />

                    </div>
                  </div>
                </div>
              </div>
              <div className="com-data-area-inner bg-white">
                <div className="Dailysalereport-content-area-main quotation-main mt-0">
                  <ul
                    className="Dailysalereport-content-area-navbar nav-tabs quotation-main-navbar mt-4"
                    id="myTab"
                    role="tablist"
                  >
                    <li
                      className="nav-item Dailysalereport-content-area-navbar-item quotation-main-navbar-item"
                      role="presentation"
                    >
                      <button
                        className="nav-link active Dailysalereport-content-area-navbar-item-link quotation-main-navbar-item-link"
                        id="Sale-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Sale"
                        type="button"
                        role="tab"
                        aria-controls="Sale"
                        aria-selected="true"
                        onClick={() => setpaytype('ALL')}
                      >
                        {t("ALL")}
                      </button>
                    </li>
                    <li
                      className={generalsettings?.data?.generalsetup?.POS_partial_payment === '1' ? "nav-item quotation-main-navbar-item" :
                        "d-none"}
                      role="presentation"
                    >
                      <button
                        className="nav-link quotation-main-navbar-item-link quotation-main-navbar-item-link-custom Dailysalereport-content-area-navbar-item-link"
                        id="Layby-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#layby"
                        type="button"
                        role="tab"
                        aria-controls="layby"
                        aria-selected="false"
                        onClick={() => setpaytype('LayBy')}
                      >
                        {t("Layby")}
                      </button>
                    </li>
                    <li
                      className={generalsettings?.data?.generalsetup?.POS_partial_payment === '1' ? "nav-item quotation-main-navbar-item" : "d-none"}
                      role="presentation"
                    >
                      <button
                        className="nav-link quotation-main-navbar-item-link Dailysalereport-content-area-navbar-item-link"
                        id="Installment-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Installment"
                        type="button"
                        role="tab"
                        aria-controls="Installment"
                        aria-selected="false"
                        onClick={() => setpaytype('Installment')}
                      >
                        {t("Installment")}
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="Sale"
                      role="tabpanel"
                      aria-labelledby="Sale-tab"
                    >
                      {renderTable('receivePaymentTable', 'ALL')}
                    </div>
                    <div
                      className="tab-pane fade "
                      id="layby"
                      role="tabpanel"
                      aria-labelledby="layby-tab"
                    >
                      {renderTable('receivePaymentTable_layby', 'LayBy')}
                    </div>
                    <div
                      className="tab-pane fade "
                      id="Installment"
                      role="tabpanel"
                      aria-labelledby="Installment-tab"
                    >
                      {renderTable('receivePaymentTable_Installment', 'Installment')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">

            {showcheckout === 'payment' ? (
              <CheckoutPayment UpdatedCart={UpdatedCart} setShowcheckout={setShowcheckout} order_id={order_id}
                custom_order_id={custom_order_id} laybylist={laybylist} greandtotal={greandtotal} laybyid={laybyid} />
            ) : (
              <CheckoutBlank />
            )}

          </div>
        </div>
      </div>
      <TableActionMenu menu={actionMenu} onClose={closeActionMenu}>
        {actionMenu ? renderActionMenuItems(actionMenu.row, actionMenu.tab) : null}
      </TableActionMenu>
    </>
  )
}

export default ReceivePayment;
